/* eslint react/prop-types: 0 */
import React from 'react';

import ProfileLink, { HorseLink, TrainerLink } from '../../shared/links/ProfileLink';
import StakeCell from '../../shared/cells/StakeCell';

const humanColumnsFactory = type => [
    {
        key: 'styleName',
        header: `Top ${type}`,
        cell: (row) => {
            const StaffLink = ProfileLink[type];
            const nameProp = {
                [`${type}StyleName`]: row.styleName,
            };
            return <StaffLink {...row} {...nameProp} />;
        },
    },
    {
        key: 'wins',
        header: `wins-${type === 'jockey' ? 'rides' : 'runs'}`,
        cell: ({ wins, runs }) => `${wins}-${runs}`,
    },
    {
        key: 'winPercent',
        header: '%',
    },
    {
        key: 'stake',
        header: '£1 stake',
        cell: StakeCell,
    },
];

const horse = [
    {
        key: 'styleName',
        header: 'Course Specialist',
        cell: ({ horseUid, styleName }) =>
            <HorseLink horseStyleName={styleName} horseUid={horseUid} />,
    },
    {
        key: 'wins',
        header: 'wins-runs',
        cell: ({ wins, runs }) => `${wins}-${runs}`,
    },
    {
        key: 'winPercent',
        header: '%',
    },
    {
        key: 'trainerName',
        header: 'Trainer',
        cell: ({ trainerUid, trainerName }) =>
            <TrainerLink trainerStyleName={trainerName} trainerUid={trainerUid} />,
    },
    {
        key: 'topRpr',
        header: 'Best Course RPR',
    },
    {
        key: 'stake',
        header: '£1 stake',
        cell: StakeCell,
    },
];

export default {
    topJockeys: humanColumnsFactory('jockey'),
    topTrainers: humanColumnsFactory('trainer'),
    topHorses: horse,
    topOwners: humanColumnsFactory('owner'),
};



// WEBPACK FOOTER //
// ./src/js/course/stats/columns.jsx